import { NavLink } from "react-router";
import number_format from "../../utils/number_format";
import { PartnerApi } from "../../api/partner.api";
import { useTranslation } from "../../hooks/useTranslation";

export default function InvoiceRow({
  awailableColumns,
  selectedColumns,
  invoice,
  checkbox,
  token,
  downloadButtonIsOpen,
  setDownloadButtonIsOpen,
  setInvoiceToShow,
  setShowModal,
  showCompanyDetail,
}) {
  const { t } = useTranslation();
  return (
    <tr>
      {false && checkbox !== false && (
        <td>
          <div className="form-check form-check-sm form-check-custom form-check-solid">
            <input
              className="form-check-input"
              type="checkbox"
              value={invoice.invoice_id}
            />
          </div>
        </td>
      )}

      {Object.keys(awailableColumns)
        .filter((awailableColumnsKey) =>
          selectedColumns.includes(awailableColumnsKey)
        )
        .map((awailableColumnsKey) => (
          <td
            key={awailableColumnsKey}
            className={
              ["total_amount_currency"].includes(awailableColumnsKey) &&
              "text-end"
            }
          >
            {["issued_by", "invoice_id", "opportunity_id"].includes(
              awailableColumnsKey
            ) && invoice[awailableColumnsKey]}
            {[
              "invoice_date",
              "invoice_paid_date",
              "invoice_tax_date",
              "invoice_due_date",
            ].includes(awailableColumnsKey) &&
              (invoice[awailableColumnsKey]
                ? new Date(invoice[awailableColumnsKey]).toLocaleDateString()
                : "n/a")}
            {"description" == awailableColumnsKey && (
              <>
                <a href={"/prilezitost/" + invoice.opportunity_id}>
                  {invoice.description}
                </a>
                <div className="fs-8">
                  <a
                    href={"/klient/" + invoice.end_customer?.company_id}
                    onClick={(e) => {
                      showCompanyDetail &&
                        showCompanyDetail(invoice.end_customer?.company_id);
                      e.preventDefault();
                    }}
                  >
                    {invoice.end_customer?.name}
                  </a>
                </div>
              </>
            )}
            {"invoice_number" == awailableColumnsKey && (
              <>
                <a
                  href="javascript:;"
                  onClick={() => {
                    setShowModal(true);
                    setInvoiceToShow(invoice.invoice_id);
                  }}
                >
                  {invoice.invoice_number}
                </a>
                {invoice.vendors && invoice.vendors[0] && (
                  <>
                    <div>
                      <span
                        className={
                          "badge badge-secondary mt-3 badge-vendor-" +
                          invoice.vendors[0].vendor_id
                        }
                      >
                        {invoice.vendors[0].name}
                      </span>
                    </div>
                    <img
                      className="mw-100 mt-5 d-none"
                      xstyle={{
                        aspectRatio: "1 / 1",
                        objectFit: "contain",
                      }}
                      src={
                        PartnerApi.url +
                        "/vendor/" +
                        invoice.vendors[0].vendor_id +
                        "/logo.jpg"
                      }
                      alt={invoice.vendors[0].name}
                    />
                  </>
                )}
              </>
            )}

            {"status" == awailableColumnsKey && (
              <span className={"badge badge-" + invoice.status.status_style}>
                {invoice.status.status_description}
              </span>
            )}

            {"total_amount_currency" == awailableColumnsKey && (
              <>
                {number_format(invoice.total_amount_currency, 2, ",", ".")}
                &nbsp;{invoice.invoice_currency}
                {invoice.invoice_currency !==
                  invoice.invoice_local_currency && (
                  <div className="fs-8">
                    (~&nbsp;
                    {number_format(
                      invoice.total_amount_local_currency,
                      2,
                      ",",
                      "."
                    )}
                    &nbsp;{invoice.invoice_local_currency})
                  </div>
                )}
              </>
            )}
          </td>
        ))}

      <td className="text-end">
        {invoice.download_available == true && (
          <div className="position-relative">
            <button
              onClick={() => setDownloadButtonIsOpen(invoice.invoice_id)}
              className="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary"
            >
              {t("common.download")}
              <i className="ki-duotone ki-down fs-5 ms-1"></i>
            </button>

            <div
              className={
                "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" +
                (downloadButtonIsOpen == invoice.invoice_id
                  ? " kt-menu-action--is-open"
                  : "")
              }
              data-kt-menu="true"
            >
              <div className="menu-item px-3">
                <a
                  href="#"
                  onClick={() =>
                    PartnerApi.download(
                      "/invoice/" + invoice.invoice_id + "/download.pdf",
                      "faktura_" + invoice.invoice_id + ".pdf",
                      token
                    )
                  }
                  className="menu-link px-3"
                >
                  PDF
                </a>
              </div>
              <div className="menu-item px-3">
                <a
                  href="#"
                  onClick={() =>
                    PartnerApi.download(
                      "/invoice/" + invoice.invoice_id + "/download.isdoc",
                      "faktura_" + invoice.invoice_id + ".isdoc",
                      token
                    )
                  }
                  className="menu-link px-3"
                >
                  ISDOC
                </a>
              </div>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
}
